import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { OrganisationSettingsForm } from "@/components/OrganisationSettingsForm";

export interface OrganisationSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSaved?: () => void;
  scrollToBankDetails?: boolean;
  mode?: "ar-onboarding" | "ap-onboarding";
}

export function OrganisationSettingsDialog({
  open,
  onOpenChange,
  onSaved,
  scrollToBankDetails = false,
  mode = "ar-onboarding",
}: OrganisationSettingsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Set up your account</DialogTitle>
          <DialogDescription>
            Add your business details, bank account, and preferences before getting started.
          </DialogDescription>
        </DialogHeader>
        <OrganisationSettingsForm
          mode={mode}
          scrollToBankDetails={scrollToBankDetails}
          onSaveSuccess={() => {
            onOpenChange(false);
            onSaved?.();
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
